import { ApiClient } from "@common/services/ApiClient"
import configProvider from "@common/services/configProvider"

export default new ApiClient(configProvider.get("CORE_API_WORKER_PATH") || "core-api-worker")
